import React from "react";
import { BarChart } from "@mui/x-charts/BarChart";
// import { blueberryTwilightPalette } from "@mui/x-charts/colorPalettes";
import { LocalizationProvider } from "@mui/x-date-pickers-pro/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers-pro/AdapterDayjs";
import dayjs from "dayjs";

type CustomBarChartProps = {
    chartData: {
        labels: string[];
        values: number[][];
        seriesLabels: string[]; // ✅ more generic name
        showFullDateLabels?: boolean;
        showSeriesLabels?: boolean;
    };
};

const CustomBarChart: React.FC<CustomBarChartProps> = ({ chartData }) => {
    console.log("Labels:", chartData.labels);
    console.log("Series Labels:", chartData.seriesLabels);
    console.log("Values:", chartData.values);

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <div className="">
                <BarChart
                    borderRadius={10}
                    // colors={blueberryTwilightPalette}
                    xAxis={[
                        {
                            data: chartData.labels,
                            scaleType: "band",
                            valueFormatter: (value: string) => {
                                const date = dayjs(value);

                                if (chartData.showFullDateLabels) {
                                    const weekday = date.format("ddd");
                                    const day = date.format("D");
                                    const month = date.format("MMMM");
                                    const capitalizedWeekday =
                                        weekday.charAt(0).toUpperCase() +
                                        weekday.slice(1);
                                    const capitalizedMonth =
                                        month.charAt(0).toUpperCase() +
                                        month.slice(1);
                                    return `${capitalizedWeekday}\n${day}. ${capitalizedMonth}`;
                                } else {
                                    const month = date.format("MMMM");
                                    const capitalizedMonth =
                                        month.charAt(0).toUpperCase() +
                                        month.slice(1);
                                    return capitalizedMonth;
                                }
                            },
                        },
                    ]}
                    series={chartData.seriesLabels.map((label, idx) => ({
                        data: chartData.values.map((val) => val[idx]),
                        ...(chartData.showSeriesLabels ? { label } : {}), // 👈 Only add label if true
                        stack: "stack1",
                        valueFormatter: (value) => `${value}`,
                    }))}
                    slotProps={{
                        legend: {
                            position: {
                                vertical: "bottom",
                                horizontal: "center",
                            },
                            sx: {
                                gap: "8px",
                                // CSS-in-JS
                                [".MuiChartsLegend-mark"]: {
                                    height: 3,
                                    width: 3,
                                },
                                // CSS class
                                [".MuiChartsLegend-series"]: {
                                    gap: "4px",
                                },
                            },
                        },
                    }}
                    margin={{
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                    }}
                    // height={150}
                    // margin={{ bottom: 120 }}
                    grid={{ vertical: false, horizontal: true }}
                    sx={{
                        "& .MuiChartsAxis-left .MuiChartsAxis-line": {
                            display: "none",
                        },
                        "& .MuiChartsAxis-tickLabel span:first-of-type": {
                            fontWeight: "bold",
                        },
                        "& .MuiChartsAxis-bottom .MuiChartsAxis-line": {
                            display: "none",
                        },
                        "& .MuiChartsGrid-horizontalLine": {
                            stroke: "white",
                            strokeDasharray: "1 4",
                        },
                        "& .MuiChartsAxis-left .MuiChartsAxis-tickLabel": {
                            fill: "#000000", // Set label color
                            fontSize: 12,
                            fontFamily: "Roboto",
                        },
                        // "& .MuiChartsGrid-line": {
                        //     display: "none",
                        // },
                        // "& .MuiChartsAxis-left .MuiChartsAxis-tickLabel": {
                        //     display: "none",
                        // },
                        // "& .MuiChartsAxis-bottom .MuiChartsAxis-tickLabel": {
                        //     transform: "rotate(45deg)", // Rotate labels 45 degrees
                        //     transformOrigin: "end", // Ensure the rotation happens from the center
                        //     textAnchor: "start", // Adjust alignment
                        // },
                        "& .MuiChartsAxis-bottom .MuiChartsAxis-tick": {
                            display: "none",
                        },
                        "& .MuiChartsAxis-left .MuiChartsAxis-tick": {
                            display: "none",
                        },
                    }}
                />
            </div>
        </LocalizationProvider>
    );
};

export default CustomBarChart;
